import { render, staticRenderFns } from "./leftChart2.vue?vue&type=template&id=35638a60&"
import script from "./leftChart2.vue?vue&type=script&lang=js&"
export * from "./leftChart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports